import { easeInOutQuad } from './util';
export class TabsStroll {
	private _active: string | null = null;
	private interval: NodeJS.Timeout | null = null;
	constructor(private $el: HTMLElement) {
		const handleClick = this.handleClick.bind(this);
		this.active = this.$el.querySelector<HTMLElement>('[data-target]')!.dataset.target as string;
		// if (!this._active) {
		// 	throw new Error('');
		// }
		Array.from(this.$el.querySelectorAll<HTMLElement>('[data-target]')).forEach(($el, index) => {
			$el.addEventListener('click', handleClick);
		});
	}

	private handleClick(event: Event) {
		event.preventDefault();
		const $target: HTMLElement = (event.target as HTMLElement).closest('[data-target]') as HTMLElement;

		if ($target.dataset.target) {
			const target = $target.dataset.target;
			this.active = target;
		}
	}

	set active(value: string) {
		const setHeight = this.setHeight.bind(this);
		// if (this.interval) {
		// 	clearInterval(this.interval);
		// }
		const to = this.$el.querySelector(`[data-id="${value}"]`);
		if (!to) {
			this._active = null;
			throw new Error();
		}
		this._active = value;
		const contentWrap: HTMLDivElement | null = this.$el.querySelector('.tabs-scroll__scrollpanel');
		if (contentWrap) {
			const scrollLeft =
				to.getBoundingClientRect().left - this.$el.getBoundingClientRect().left + contentWrap.scrollLeft;
			this.scrollToLeft(contentWrap, scrollLeft, 500);
			this.setHeight();
			Array.from(this.$el.querySelectorAll<HTMLElement>('[data-target]')).forEach(($el) => {
				$el.parentElement!.classList.toggle('active', $el.dataset.target === value);
			});
			this.interval = setInterval(setHeight, 500);
		}
	}

	private setHeight() {
		const contentWrap: HTMLDivElement | null = this.$el.querySelector('.tabs-scroll__scrollpanel');
		const to = this.$el.querySelector(`[data-id="${this._active}"]`);
		// console.log(to);
		if (contentWrap && to) {
			contentWrap.parentElement!.style.height = to.querySelector('div')!.getBoundingClientRect().height + 100 + 'px';
		}
	}
	private scrollToLeft(element: HTMLDivElement, to: number, duration = 100) {
		const start = element.scrollLeft;
		const change = to - start;
		let currentTime = 0;
		const increment = 20;
		const animateScroll = function () {
			currentTime += increment;
			const val = easeInOutQuad(currentTime, start, change, duration);
			element.scrollLeft = val;
			if (currentTime < duration) {
				setTimeout(animateScroll, increment);
			}
		};
		animateScroll();
	}
}
